'use strict';

module.exports = require('./node-progress');
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/get-it/lib/middleware/progress/index.js
// module id = 382
// module chunks = 0